let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8eRHg"), load("1mjYg")]).then(() => parcelRequire('lhP7Q'));